import styled from 'styled-components';

export const PROGRESS_BAR_HEIGHT = 4;

export const Container = styled.div`
  min-height: ${PROGRESS_BAR_HEIGHT}px;
`;
